import { DragOutlined } from '@ant-design/icons';
import { useDraggable } from '@dnd-kit/core';
import { Space, Tag } from 'antd';
import React from 'react';

const DraggableVehicleChip = ({ isEditing, onRemove, showRemove, vehicle }) => {
  const { attributes, isDragging, listeners, setNodeRef } = useDraggable({
    data: {
      type: 'vehicle',
      vehicle,
    },
    id: `vehicle-${vehicle.id}`,
  });

  const style = {
    cursor: isEditing ? 'grab' : 'default',
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <Tag
      ref={setNodeRef}
      className="class-list__vehicle-chip"
      closable={showRemove && isEditing}
      style={style}
      onClose={onRemove}
      {...(isEditing ? { ...attributes, ...listeners } : {})}
    >
      <Space size={4}>
        {isEditing && <DragOutlined />}
        {vehicle.name}
      </Space>
    </Tag>
  );
};

export default DraggableVehicleChip;

